import { GPSPosition } from "../GPS-position";
import { COFRAC } from "./cofrac";
import { EchantillonnagePhyto } from "./echantillonnage-phyto";
import { EMaterielEauIntegrePhyto } from "./enum/materiel-eau-integre";

export class PrelPhyto {
    SampleCode: string;
    Date: Date;
    Materiel: EMaterielEauIntegrePhyto;
    ReferenceMateriel: string;
    VolumeFinal: number;
    VolumeLugolQuantitatif: number;
    CodeFilet: string;
    PlageProfondeurDebut: number;
    PlageProfondeurFin: number;
    VolumeLugolQualitatif: number;
    Comment: string;

    GPSPosition: GPSPosition = new GPSPosition();
    COFRAC: COFRAC = new COFRAC();
    EchantillonnagePhytoList: EchantillonnagePhyto[] = [];

    static mapFromJSON(json: any): PrelPhyto {
        const p = new PrelPhyto();
        p.SampleCode = json.sampleCode;
        p.Date = json.date;
        p.Materiel = json.materiel;
        p.ReferenceMateriel = json.referenceMateriel;
        p.VolumeFinal = json.volumeFinal;
        p.VolumeLugolQualitatif = json.volumeLugolQualitatif;
        p.CodeFilet = json.codeFilet;
        p.PlageProfondeurDebut = json.plageProfondeurDebut;
        p.PlageProfondeurFin = json.plageProfondeurFin;
        p.VolumeLugolQuantitatif = json.volumeLugolQuantitatif;
        p.Comment = json.comment;;

        if (json.cofrac) {
            p.COFRAC = COFRAC.mapFromJSON(json.cofrac);
        }
        if (json.gpsPosition) {
            p.GPSPosition = GPSPosition.mapFromJSON(json.gpsPosition);
        }
        if (json.echantillonnagePhytoList) {
            p.EchantillonnagePhytoList = json.echantillonnagePhytoList.map(jsonItem => EchantillonnagePhyto.mapFromJSON(jsonItem));
        }
        return p;
    }
}